import React from "react";
import { CurvedPill } from "web/react/components/filters-emo/curved-pill";
import { Rail } from "web/react/components/rail/rail";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import {
    RelatedLinkSerializer,
    RelatedProductCard,
    RelatedSearchRailSerializer,
} from "web/types/serializers";
import styles from "./related-searches-rail.module.css";

interface RelatedSearchesRailProps {
    relatedSearches?:
        | RelatedLinkSerializer[]
        | RelatedSearchRailSerializer[]
        | RelatedProductCard[];
    title?: string;
    onClick: () => void;
}

export function RelatedSearchesRail({
    relatedSearches,
    title,
    onClick,
}: RelatedSearchesRailProps): JSX.Element {
    const analyticsLabel = "related_searches";

    return (
        <Rail title={title} analyticsLabel={analyticsLabel} shouldWrap alwaysWrap>
            {relatedSearches?.map((relatedSearch, index) => {
                return (
                    <a
                        href={relatedSearch.url}
                        key={`related-searches-pill-${index}`}
                        className={styles.relatedSearchPill}
                        itemProp={relatedSearch?.is_breadcrumb ? "item" : undefined}
                    >
                        <CurvedPill
                            as="div"
                            label={relatedSearch.text || relatedSearch.name}
                            onClick={onClick}
                            icon={<SVGIcon name="search" />}
                            active={false}
                            activeHighlighted={false}
                        />
                    </a>
                );
            })}
        </Rail>
    );
}
